import React from 'react';
import { Row, Col, Button, Typography } from 'antd';
import AccountStructureComponent from '../AccountTable';


const { Title } = Typography;

const TabContent = ({
  accounts,
  ftype,
  title,
  wrapperRef,
  // shared state
  accountStructure,
  organization,
  periods,
  expandedPeriods,
  selectedRowKey,
  setSelectedRowKey,
  selectedAccount,
  columnWidths,
  setColumnWidth,
  // shared handlers
  handlers,
  // tab-specific
  onAddAccount,
  onOpenAccountManagement,
  onShowAccountInfo,
  onShowWhereUsed,
  focusRequest,
}) => {
  const tableSection = (
    <AccountStructureComponent
      accounts={accounts}
      accountStructure={accountStructure}
      organization={organization}
      periods={periods}
      expandedPeriods={expandedPeriods}
      selectedRowKey={selectedRowKey}
      setSelectedRowKey={setSelectedRowKey}
      handleUpdateAccount={handlers.handleUpdateAccount}
      handleCreateSubAccount={handlers.handleCreateSubAccount}
      handleDeleteAccount={handlers.handleDeleteAccount}
      handleMoveAccountUp={handlers.handleMoveAccountUp}
      handleMoveAccountDown={handlers.handleMoveAccountDown}
      handleMoveAccountLeft={handlers.handleMoveAccountLeft}
      handleMoveAccountRight={handlers.handleMoveAccountRight}
  
      handleInsertAccount={handlers.handleInsertAccount}
      handleSetSelectedAccount={handlers.handleSetSelectedAccount}
      handleSetExpandedPeriods={handlers.handleSetExpandedPeriods}

      handleCreateSeparator={handlers.handleCreateSeparator}
      handleUpdateSeparator={handlers.handleUpdateSeparator}
      handleDeleteSeparator={handlers.handleDeleteSeparator}
      handleMoveSeparator={handlers.handleMoveSeparator}

      columnWidths={columnWidths}
      setColumnWidth={setColumnWidth}
      ftype={ftype}

      onOpenAccountManagement={onOpenAccountManagement}
      onShowAccountInfo={onShowAccountInfo}
      onShowWhereUsed={onShowWhereUsed}
      focusRequest={focusRequest}
    />
  );

  return (
    <>
      {title && (
        <Title level={4} style={{ textAlign: 'left', marginTop: '40px' }}>
          {title}
        </Title>
      )}
      <Row>
        <Col span={12} />
        <Col span={12}>
          <Button
            type="primary"
            style={{ float: 'right', marginRight: '40px', marginBottom: '6px' }}
            disabled={!selectedAccount}
            onClick={(e) => {
              e.stopPropagation();
              onOpenAccountManagement?.(selectedAccount);
                        }}
          >
            Account Management
          </Button>
        </Col>
      </Row>

      {wrapperRef ? <div ref={wrapperRef}>{tableSection}</div> : tableSection}

      <Button
        type="primary"
        style={{ float: 'right', marginRight: '40px', marginTop: '10px' }}
        onClick={onAddAccount}
      >
        Add account
      </Button>
    </>
  );
};

export default TabContent;